module.exports = __webpack_public_path__ + "img/UTGUNL-2.1bd0a5da.jpg";